<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="">
                <div class="card-body">
                    <app-stepper-component [steps]="3" [step]="stepActual" (stepChanged)="onStepChange($event)"
                    [icons]="['fa-solid fa-plus','fa-solid fa-upload', 'fa-solid fa-arrow-pointer']"
                     [animation] = 'animationArray'>
                        <ng-template>
                            <batch-configuration-plantilla-component
                                [resolucionInicialActiva]="resolucionInicialActiva"
                                (dataAddPlantilla)="dataPlantilla($event)"
                                (stepRedirect)="stepActual = $event">
                            </batch-configuration-plantilla-component>
                        </ng-template>
                        <ng-template>
                            
                            <subida-documento-plantilla-component
                                [dataPlantilla]="returAddPlantilla"
                                [resolucionInicialActiva]="resolucionInicialActiva"
                                (stepRedirect)="stepActual = $event">
                            </subida-documento-plantilla-component>
                        </ng-template>
                        <ng-template>
                            
                            <asociacion-firma-plantilla [dataPlantilla]="returAddPlantilla"></asociacion-firma-plantilla>
                        </ng-template>
                    </app-stepper-component>
                </div>
            </div>
        </div>
    </div>
</div>